import type { ReactNode } from 'react'

// ErrorBanner — inline error surface for forms and panels. Uses
// role="alert" so screen readers announce it when it appears.
export function ErrorBanner({
  children,
  className = '',
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      role="alert"
      className={`rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300 ${className}`}
    >
      {children}
    </div>
  )
}
